import { useEffect, useState } from "react";
import { Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import { TConfig } from "../constants/types";
import React from "react";
import styles from "../styles/admin.module.scss";

export interface IStylingProps {
    token: string;
    username: string;
    site: string;
    apiUrl: string;
    setMessage: Function;
    setError: Function;
    setConfirm: Function;
}

const Configuration: React.FunctionComponent<IStylingProps> = (props: IStylingProps) => {
    const [uconfigs, setuconfigs] = useState<TConfig[]>([]);
    const [configs, setconfigs] = useState<TConfig[]>([]);
    const [reload, setreload] = useState<any>();

    useEffect(() => {
        fetch(`${props.apiUrl}/GetConfig?username=${props.username}&token=${props.token}&site=${props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data: TConfig[]) => {
            setconfigs(data);
            setuconfigs(data);
        }).catch(err => {
            console.log(err);
        });
    }, [reload]);

    function save() {
        let items : TConfig[] = [];

        uconfigs.forEach(uconfig => {
            configs.forEach(config => {
                if (uconfig.id === config.id) {
                    if (uconfig.value !== config.value) {
                        items.push(uconfig);
                    }
                }
            });
        });

        if (items.length) {
            fetch(`${props.apiUrl}/SetConfig`, {
                method: "Post", 
                mode: "cors", 
                headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Accept-Encoding": "gzip, deflate ,br"
                },
                referrerPolicy: "origin-when-cross-origin", 
                body: JSON.stringify({token: props.token, username: props.username, site: props.site, items: items}), 
            }).then((response) => response.json()).then((data) => data).then((success:boolean) => {
                if (success) {
                    setreload(Date.now);
                    props.setMessage("Nieuwe configuratie opgeslagen.");
                } else {
                    props.setError("Opslag configuratie gefaald.");
                }
                props.setConfirm(undefined);
            }).catch((ex) => {
                props.setError(ex);
            });
        } else {
            props.setError("Geen wijzigingen om op te slaan.");
        }
    }

    function updateValue(id: number, value: string) {
        let newConfigs : TConfig[] = [];
        uconfigs.forEach(config => {
            if (config.id === id) {
                newConfigs.push({id:id, name: config.name, value: value})
            } else {
                newConfigs.push(config);
            }
        });
        setuconfigs(newConfigs);
    }

    function SaveConfirmed() {
        props.setConfirm(save);
    }

    return (
        <Stack horizontalAlign="start" style={{ height: "100%", width: "100%", padding: 10, overflow: "hidden" }}>
            <Stack style={{ width: "100%", backgroundColor: "lightgreen" }}>
                <h2 style={{ paddingLeft: 10 }}>Configuratie</h2>
            </Stack>
            <Stack style={{width:"100%"}}>
                <table className={styles.configTable}>
                    <tr>
                        <th style={{width:"200px"}}>
                            Naam
                        </th>
                        <th>
                            Waarde
                        </th>
                    </tr>
                    {uconfigs.map(config => {
                        return <tr>
                            <td>
                                <Label>{config.name}</Label>
                            </td>
                            <td>
                                <TextField className={styles.searchBox} value={config.value} onChange={(e,v) => { updateValue(config.id,v); }} />
                            </td>
                        </tr>
                    })}
                </table>
            </Stack>
            <Stack horizontalAlign="end" style={{width:"100%"}}>
                <PrimaryButton text="Opslaan" onClick={SaveConfirmed} />
            </Stack>
        </Stack>
    );
}

export default Configuration;